import { parseToRgba } from 'color2k';

/**
 * Get the perceived brightness of a color as percentage in decimal form.
 *
 * @param {string} color
 * @return number A number from 0 to 1, 1 being the brightest and 0 not bright at all.
 */
export const perceivedBrightness = (color: string): number => {
    // Convert hex to RGB
    const [red, green, blue] = parseToRgba(color);

    // Calculate perceived brightness from RGB (http://alienryderflex.com/hsp.html)
    const perceivedBrightness = Math.sqrt(0.299 * (red * red) + 0.587 * (green * green) + 0.114 * (blue * blue));

    // Return perceived brightness as percentage in decimal form
    return Math.round(perceivedBrightness / 2.55) / 100;
};



/**
 * Find out if one color is brighter than another color.
 *
 * @param {string} colorA
 * @param {string} colorB
 * @return boolean True if colorA is brighter than colorB.
 */
export const colorBrighterThan = (colorA: string, colorB: string): boolean => perceivedBrightness(colorA) > perceivedBrightness(colorB);

/**
 * Determine if a color is to be considered dark (luma < 128).
 *
 * @param {string} colorA
 * @param {string} colorB
 * @return boolean True if color1 is brighter than color2.
 */
export const colorIsDark = (colorA: string): boolean => perceivedBrightness(colorA) < 0.5;
